import React, { Component } from 'react';

import FrameComponents from "../../../FrameComponents"; 

class indexNew extends Component {

  state = {

  };

  //进入页面调用接口
  componentDidMount() {

  }

  render() {
   
    return (
      <FrameComponents name="ImageOptimizationSettings" />
    );
    
  }
}

export default indexNew;
